const theme = {
  colors: {
    primary: '#213f9a',
    primaryDark: '#1A2E6A',
    primaryLight: '#3a5bc7',
    primaryBg: '#eef1f9',

    success: '#1b9e3e',
    successLight: '#93d271',
    successLighter: '#e6f5df',
    successHover: '#72C546',
    successBadge: '#76c24e',

    error: '#dc3545',
    errorLight: '#f8d7da',
    errorDark: '#b80000',
    warning: '#FF5C57',

    gray50: '#f8f9fa',
    gray100: '#f1f3f5',
    gray200: '#ededed',
    gray300: '#dee2e6',
    gray400: '#adb5bd',
    gray500: '#74747b',
    gray600: '#6f6f6f',
    gray700: '#495057',
    gray800: '#343a40',
    gray900: '#212529',

    white: '#ffffff',
    black: '#000000',
    overlay: 'rgba(0, 0, 0, 0.5)',
  },

  fonts: {
    family: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    xs: '0.75rem',
    sm: '0.8125rem',
    base: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
  },

  space: {
    1: '4px',
    2: '8px',
    3: '12px',
    4: '16px',
    5: '20px',
    6: '24px',
    7: '32px',
    8: '40px',
    9: '48px',
    10: '64px',
  },

  radius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    full: '9999px',
  },

  shadows: {
    sm: '0 1px 2px rgba(0,0,0,0.05)',
    md: '0 4px 6px rgba(0,0,0,0.07), 0 1px 3px rgba(0,0,0,0.06)',
    lg: '0 10px 15px rgba(0,0,0,0.1), 0 4px 6px rgba(0,0,0,0.05)',
    xl: '0 20px 25px rgba(0,0,0,0.1), 0 10px 10px rgba(0,0,0,0.04)',
  },

  transitions: {
    fast: '150ms ease',
    base: '250ms ease',
    slow: '350ms ease',
  },

  zIndex: {
    dropdown: 100,
    sticky: 200,
    overlay: 300,
    modal: 400,
    toast: 500,
  },
};

export default theme;
